<template>
  <div class="container age-check viewport" v-if="ageCheckConfirmed === null">
    <div class="container-age-gate">
      <div class="box-age-gate">
        <img :src="logo" alt="logo" class="logo-jm" />
        <div class="message">
          {{ $t("age_check.message") }}
        </div>
        <div class="sub-message">
          {{ $t("age_check.enter_birthday") }}
        </div>
        <div class="button-group">
          <button
            @click="handleClick('yes')"
            type="button"
            class="button-age-check"
          >
            {{ $t("age_check.yes") }}
          </button>
          <button
            @click="handleClick('no')"
            type="button"
            class="button-age-check"
          >
            {{ $t("age_check.no") }}
          </button>
        </div>
      </div>
      <div class="footer">
        <div class="image-container">
          <img
            :src="drinkResponsible"
            alt="drink responsible"
            class="logo logo-responsibly"
          />
        </div>
        <PrivacyPolicy />
      </div>
    </div>
    <TermsOverlay class="is-scrollable" v-if="termsOverlayOpen" />
  </div>

  <div
    class="container age-check viewport viewport-failed"
    v-else-if="ageCheckConfirmed === false"
  >
    <AgeCheckFailed />
  </div>
</template>

<script>
import AgeCheckFailed from "./AgeCheckFailed.vue";
import Logo from "@/assets/images/logo_jaegermeister_white.svg";
import drinkResponsible from "@/assets/images/drink-responsible.svg";
import PrivacyPolicy from "./PrivacyPolicy.vue";
import TermsOverlay from "@/components/TermsOverlay";
import { useGameTracking } from "@/composables/useGameTracking";

export default {
  data() {
    return {
      ageCheckConfirmed: null,
      logo: Logo,
      drinkResponsible: drinkResponsible,
    };
  },
  components: {
    AgeCheckFailed,
    PrivacyPolicy,
    TermsOverlay,
  },
  computed: {
    termsOverlayOpen() {
      return this.$store.state.termsOverlay;
    },
  },
  methods: {
    async handleClick(answer) {
      const { kpiTracker, session } = useGameTracking();

      if (answer === "yes") {
        // Setze Consent auf true
        kpiTracker.setConfirmedConsent(true);

        // Setze Progress auf 1 (age_gate_clicked)
        kpiTracker.setProgress(1);

        // Update Session mit Progress "age_gate_clicked"
        try {
          await session.updateSessionProgress(kpiTracker.getKpiData(), {
            step: "age_gate_clicked",
          });
        } catch (error) {
          console.error("Error updating session:", error);
        }

        this.$emit("ageValidated");
      } else {
        // Setze Progress auf 1 (age_gate_clicked)
        kpiTracker.setProgress(1);

        // Update Session mit Progress "age_gate_clicked"
        try {
          await session.updateSessionProgress(kpiTracker.getKpiData(), {
            step: "age_gate_clicked",
          });
        } catch (error) {
          console.error("Error updating session:", error);
        }

        this.ageCheckConfirmed = false;
      }
    },
  },
};
</script>

<style scoped>
.age-check {
  z-index: 300;
}
.viewport {
  background-image: url("~@/assets/images/bg-green-xl.jpg");
  background-color: black;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  background-size: cover;
}

.viewport-failed {
  background-image: url("~@/assets/images/age-gate-failed.jpg");
  background-color: black;
  background-repeat: no-repeat;
  background-position: right center;
  background-attachment: fixed;
  background-size: cover;
}
.container {
  width: 100%;
  padding: 1rem;
}

.container-age-gate {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.box-age-gate {
  border: 10px solid;
  --tw-border-opacity: 1;
  border-color: rgb(219 107 48 / var(--tw-border-opacity));
  border-radius: 3rem;
  --tw-bg-opacity: 1;
  background-color: rgb(9 50 37 / var(--tw-bg-opacity));
  max-width: 420px;
  width: 100%;
  margin-top: 15rem;
  padding: 1.5rem;
  text-align: center;
}

.logo-jm {
  width: 95px;
  margin-bottom: 1.5rem;
  margin-top: 2rem;
}

.logo-responsibly {
  width: 70px;
  margin-top: 2rem;
}

.message {
  font-size: 24px;
  white-space: nowrap;
  font-family: "Meister-Bold";
  text-transform: uppercase;
  color: #ffffff;
  margin: 0 auto;
  max-width: 320px;
}

.sub-message {
  font-size: 16px;
  color: #ffffff;
  margin: 1rem 0;
  max-width: 320px;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 3rem;
  white-space: pre-line;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.button-age-check {
  font-family: "Meister-Bold";
  padding: 1rem 5rem;
  font-size: 16px;
  font-weight: 700 !important;
  text-transform: uppercase;
  color: #065f46;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 1.25rem;
  cursor: pointer;
  --tw-text-opacity: 1;
  color: rgb(9 50 37 / var(--tw-text-opacity));
}

.footer {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 300;
}

.logo {
  width: 160px;
  margin-bottom: 1.5rem;
}
</style>

<!-- <template>
  <div class="age-check">
    <div v-if="!termsOverlayOpen">
      <div class="box h-overflow-scroll">
        <div align="center"><img src="@/assets/images/logo_jaegermeister.png" class="logo" /></div>
        <div class="age-check-input" v-if="ageCheckConfirmed === null">
          <p>{{ $t('age_check.intro') }}</p>
          <br/>
          <p class="is-text-bold is-uppercase">{{ $t('age_check.enter_birthday') }}</p>
          <br/>
          <div class="input-wrap">
            <div class="label-wrap white">
              <div class="label">{{ $t('age_check.day') }}</div>
            </div>
            <input class="white" type="number" inputmode="numeric" pattern="[0-9]*" maxlength="2" :class="['input', { 'validated' : errorDay === false }]" v-model="day" :placeholder="$t('age_check.day_placeholder')" ref="day">
          </div>
          <div class="input-wrap">
            <div class="label-wrap">
              <div class="label">{{ $t('age_check.month') }}</div>
            </div>
            <input class="white" @focus="correctDayInput()" type="number" inputmode="numeric" pattern="[0-9]*" :class="['input', { 'validated' : errorMonth === false }]" v-model="month" :placeholder="$t('age_check.month_placeholder')" ref="month">
          </div>
          <div class="input-wrap">
            <div class="label-wrap">
              <div class="label">{{ $t('age_check.year') }}</div>
            </div>
            <input class="white" @focus="correctMonthInput()" type="number" inputmode="numeric" pattern="[0-9]*" :class="['input large', { 'validated' : errorYear === false }]" v-model="year" :placeholder="$t('age_check.year_placeholder')" ref="year">
          </div>
          <p v-if="errorDay" class="is-text-orange">{{ $t('age_check.error_day_message') }}</p>
          <p v-if="errorMonth" class="is-text-orange">{{ $t('age_check.error_month_message') }}</p>
          <p v-if="errorYear" class="is-text-orange">{{ $t('age_check.error_year_message') }}</p>
        </div>
      <div v-else-if="ageCheckConfirmed === false">
        <h1>{{ $t('age_check.failed') }}</h1>
      </div> -->
<!-- <div class="debug-buttons">
        <span v-if="currentStep != 'fight'" @click="currentStep = 'fight'">Fight</span>
        <span @click="currentStep = 'prologue'">Weiter</span>
      </div> -->
<!-- <PrivacyPolicy class="privacy-bar"/>
    </div>
    </div>
    <TermsOverlay class="is-scrollable" v-else/>
  </div>
</template>

<script>
import moment from 'moment'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import TermsOverlay from '@/components/TermsOverlay'
export default {
  components: { PrivacyPolicy, TermsOverlay },
  data () {
    return {
      ageCheckConfirmed: null,
      day: '',
      month: '',
      year: '',
      errorDay: null,
      errorMonth: null,
      errorYear: null
    }
  },
  computed: {
    termsOverlayOpen () {
      return this.$store.state.termsOverlay
    }
  },
  methods: {
    removeScroll () {
      document.addEventListener('touchmove', function(e) {
      if (e.cancelable) {
        e.preventDefault();
      }
      }, { passive: false });
      console.log('scroll removed')
    },
    validateBirthday () {
      if (this.errorDay === false && this.errorMonth === false && this.errorYear === false) {
        const birthday = moment(`${this.day}.${this.month}.${this.year}`, "DD.MM.YYYY")
        const age = moment.duration(moment().diff(birthday)).asYears()

        if (age >= 18) {
          this.currentStep = 'prologue'
          this.removeScroll()
        } else {
          this.ageCheckConfirmed = false
        }
      } else {
        console.log('not validating')
      }
    },
    correctDayInput () {
      if (this.day.length === 1) {
        this.day = `0${this.day}`
      }
    },
    correctMonthInput () {
      if (this.month.length === 1) {
        this.month = `0${this.month}`
      }
    }
  },
  watch: {
    day () {
      if (this.day.length === 2 && parseInt(this.day) > 0 && parseInt(this.day) <= 31) {
        this.$refs.month.focus()
        this.errorDay = false
        this.validateBirthday()
      } else {
        if (this.day.length > 1) {
          this.errorDay = true
        }
      }
    },
    month () {
      if (this.month.length === 2 && parseInt(this.month) > 0 && parseInt(this.month) <= 12) {
        this.$refs.year.focus()
        this.errorMonth = false
        this.validateBirthday()
      } else {
        if (this.month.length > 1) {
          this.errorMonth = true
        }
      }
    },
    year () {
      if (this.year.length === 4 && parseInt(this.year) > 999 && parseInt(this.year) <= moment().year()) {
        this.errorYear = false
        this.validateBirthday()
      } else {
        if (this.year.length >= 4 || parseInt(this.year) > moment().year()) {
          this.errorYear = true
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/main.sass"
.input-wrap
  position: relative
  display: flex

  .label-wrap
    flex: 0 2rem

    .label
      text-transform: uppercase
      position: absolute
      font-size: 1rem
      transform: rotate(270deg) translateX(-100%)
      top: 0
      left: 0
      transform-origin: top left
      padding-right: 1.5rem
      letter-spacing: 0.2rem
    
  input
    width: 16rem
    height: 9rem
    font-size: 8rem
    margin-bottom: 3rem
    opacity: .75
    color: white
    font-family: 'Meister-Bold', Helvetica, Arial, sans-serif

    &:focus
      opacity: 1 

    &.large
      width: 24rem

.age-check-input
  margin-top: 1rem

.age-check
  background-size: cover

p
  font-size: 1.8rem

h1
  text-align: center

.box
  background-image: url("~@/assets/images/bg-age-check.svg")
  background-repeat: no-repeat
  background-position: right center
  background-attachment: fixed
  background-size: cover

.debug-buttons
  position: fixed
  bottom: 10px
  right: 10px

  span
    margin: 8px

</style> -->
